import { render } from "./KpiAddDialog.vue?vue&type=template&id=ff46d256&scoped=true"
import script from "./KpiAddDialog.vue?vue&type=script&lang=js"
export * from "./KpiAddDialog.vue?vue&type=script&lang=js"

import "./KpiAddDialog.vue?vue&type=style&index=0&id=ff46d256&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff46d256"]])

export default __exports__